// IE needs this for airbnb react-dates to work (https://github.com/airbnb/react-dates/issues/233)
// IE and Android 4.4 need this for Set and Map polyfill. Otherwise the app doesn't start
import "airbnb-js-shims";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { unregister } from "registerServiceWorker";
import { georgeAppDidBecomeActive, georgeAppDidEnterBackground } from "./util/georgeCallbacks";
import cssVars from "css-vars-ponyfill";

// TLDR: Safari -.- 
// polyfill intl for browsers which have not implemented this api yet
// will only be injected if Intl is not provided by the browser.
// see https://github.com/andyearnshaw/Intl.js/#intljs-and-browserifywebpack
if (!global.Intl) {
    require.ensure([
        "intl",
        "intl/locale-data/jsonp/en.js",
        "intl/locale-data/jsonp/de.js"
    ], (require) => {
        require("intl");
        require("intl/locale-data/jsonp/en.js");
        require("intl/locale-data/jsonp/de.js");
        attach();
    });
} else {
    attach();
}

// Add global iOS callbacks
const _global = (window || global) as any;
_global.georgeAppDidBecomeActive = georgeAppDidBecomeActive;
_global.georgeAppDidEnterBackground = georgeAppDidEnterBackground;

function attach() {
    // Add available formattersData for this application
    // (decide which formatters are available for date-, number-, ...)
    const RI = require("react-intl");
    const formattersDataEN = require("react-intl/locale-data/en");
    const formattersDataDE = require("react-intl/locale-data/de");

    RI.addLocaleData([
        ...formattersDataEN,
        ...formattersDataDE
    ]);

    const App = require("./App").default;
    require("./assets/fonts/Inter/inter.css");
    require("./index.css");
    cssVars();

    ReactDOM.render(
        <App />,
        document.getElementById("root") as HTMLElement
    );

    unregister();
}



// WEBPACK FOOTER //
// ./src/index.tsx